/**
 * @description 装饰相关配置
 */

// 装饰组件小项配置
const decorateComponentsList = [
	{
		name: '装饰1',
		component: 'Decoration1',
		statusConfig: {
			displayShow: true,
			isShow: true, // 是否显示
			mainColor: '',
			secondaryColor: '',
		}
	},
	{
		name: '装饰2',
		component: 'Decoration2',
		statusConfig: {
			displayShow: true,
			isShow: true, // 是否显示
			mainColor: '',
			secondaryColor: '',
			dur: 6,
			reverse: false
		}
	},
	{
		name: '装饰3',
		component: 'Decoration3',
		statusConfig: {
			displayShow: true,
			isShow: true, // 是否显示
			mainColor: '',
			secondaryColor: '',
		}
	},
	{
		name: '装饰4',
		component: 'Decoration4',
		statusConfig: {
			displayShow: true,
			isShow: true, // 是否显示
			mainColor: '',
			secondaryColor: '',
			dur: 3,
			reverse: false
		}
	},
	{
		name: '装饰5',
		component: 'Decoration5',
		statusConfig: {
			displayShow: true,
			isShow: true, // 是否显示
			mainColor: '',
			secondaryColor: '',
			dur: 1.2
		}
	},
	{
		name: '装饰6',
		component: 'Decoration6',
		statusConfig: {
			displayShow: true,
			isShow: true, // 是否显示
			mainColor: '',
			secondaryColor: '',
		}
	},
	{
		name: '装饰7',
		component: 'Decoration7',
		statusConfig: {
			displayShow: true,
			isShow: true, // 是否显示
			mainColor: '',
			secondaryColor: '',
			textContent: '',
			textColor: '',
			textSize: '',
			textWeight: ''
		}
	},
	{
		name: '装饰8',
		component: 'Decoration8',
		statusConfig: {
			displayShow: true,
			isShow: true, // 是否显示
			mainColor: '',
			secondaryColor: '',
			reverse: false
		}
	},
	{
		name: '装饰9',
		component: 'Decoration9',
		statusConfig: {
			displayShow: true,
			isShow: true, // 是否显示
			mainColor: '',
			secondaryColor: '',
			dur: 3,
			textContent: '',
			textColor: '',
			textSize: '',
			textWeight: ''
		}
	},
	{
		name: '装饰10',
		component: 'Decoration10',
		statusConfig: {
			displayShow: true,
			isShow: true, // 是否显示
			mainColor: '',
			secondaryColor: '',
		}
	},
	{
		name: '装饰11',
		component: 'Decoration11',
		statusConfig: {
			displayShow: true,
			isShow: true, // 是否显示
			mainColor: '',
			secondaryColor: '',
			textContent: '',
			textColor: '',
			textSize: '',
			textWeight: ''
		}
	},
	{
		name: '装饰12',
		component: 'Decoration12',
		statusConfig: {
			displayShow: true,
			isShow: true, // 是否显示
			mainColor: '',
			secondaryColor: '',
			scanDur: 3,
			haloDur: 2
		}
	},
	{
		name: '装饰13',
		component: 'Decoration13',
		statusConfig: {
			displayShow: true,
			isShow: true, // 是否显示
			mainColor: '',
			secondaryColor: ''
		},
		style: {
			width: 576,
			height: 33
		}
	},
	{
		name: '边框1',
		component: 'BorderBox1',
		statusConfig: {
			displayShow: true,
			isShow: true, // 是否显示
			mainColor: '',
			secondaryColor: '',
			textContent: '',
			textColor: '',
			textSize: '',
			textWeight: ''
		}
	},
	{
		name: '边框2',
		component: 'BorderBox2',
		statusConfig: {
			isShow: true, // 是否显示
			mainColor: '',
			secondaryColor: '',
			textContent: '',
			textColor: '',
			textSize: '',
			textWeight: ''
		}
	},
	{
		name: '边框3',
		component: 'BorderBox3',
		statusConfig: {
			displayShow: true,
			isShow: true, // 是否显示
			mainColor: '',
			secondaryColor: '',
			textContent: '',
			textColor: '',
			textSize: '',
			textWeight: ''
		}
	},
	{
		name: '边框4',
		component: 'BorderBox4',
		statusConfig: {
			displayShow: true,
			isShow: true, // 是否显示
			mainColor: '',
			secondaryColor: '',
			textContent: '',
			textColor: '',
			textSize: '',
			textWeight: '',
			reverse: false
		}
	},
	{
		name: '边框5',
		component: 'BorderBox5',
		statusConfig: {
			displayShow: true,
			isShow: true, // 是否显示
			mainColor: '',
			secondaryColor: '',
			textContent: '',
			textColor: '',
			textSize: '',
			textWeight: '',
			reverse: false
		}
	},
	{
		name: '边框6',
		component: 'BorderBox6',
		statusConfig: {
			displayShow: true,
			isShow: true, // 是否显示
			mainColor: '',
			secondaryColor: '',
			textContent: '',
			textColor: '',
			textWeight: '',
			textSize: ''
		}
	},
	{
		name: '边框7',
		component: 'BorderBox7',
		statusConfig: {
			displayShow: true,
			isShow: true, // 是否显示
			mainColor: '',
			secondaryColor: '',
			textContent: '',
			textColor: '',
			textSize: '',
			textWeight: ''
		}
	},
	{
		name: '边框8',
		component: 'BorderBox8',
		statusConfig: {
			displayShow: true,
			isShow: true, // 是否显示
			mainColor: '',
			secondaryColor: '',
			dur: 3,
			reverse: false,
			textContent: '',
			textColor: '',
			textWeight: '',
			textSize: ''
		}
	},
	{
		name: '边框9',
		component: 'BorderBox9',
		statusConfig: {
			displayShow: true,
			isShow: true, // 是否显示
			mainColor: '',
			secondaryColor: '',
			textContent: '',
			textColor: '',
			textSize: '',
			textWeight: ''
		}
	},
	{
		name: '边框10',
		component: 'BorderBox10',
		statusConfig: {
			displayShow: true,
			isShow: true, // 是否显示
			mainColor: '',
			secondaryColor: '',
			textContent: '',
			textColor: '',
			textSize: '',
			textWeight: ''
		}
	},
	{
		name: '边框11',
		component: 'BorderBox11',
		statusConfig: {
			displayShow: true,
			isShow: true, // 是否显示
			mainColor: '',
			secondaryColor: '',
			title: '',
			titleWidth: '',
			textContent: '',
			textColor: '',
			textSize: '',
			textWeight: ''
		}
	},
	{
		name: '边框12',
		component: 'BorderBox12',
		statusConfig: {
			displayShow: true,
			isShow: true, // 是否显示
			mainColor: '',
			secondaryColor: '',
			textContent: '',
			textColor: '',
			textSize: '',
			textWeight: ''
		}
	},
	{
		name: '边框13',
		component: 'BorderBox13',
		statusConfig: {
			displayShow: true,
			isShow: true, // 是否显示
			mainColor: '',
			secondaryColor: '',
			textContent: '',
			textColor: '',
			textSize: '',
			textWeight: ''
		}
	},
	{
		name: '边框14',
		component: 'BorderBox14',
		statusConfig: {
			displayShow: true,
			isShow: true, // 是否显示
			mainColor: '',
			secondaryColor: '',
			title: '',
			titleWidth: '250',
			textContent: '',
			textColor: '',
			textSize: '',
			textWeight: '',
			blur: 6
		}
	},
	{
		name: '边框15',
		component: 'BorderBox15',
		statusConfig: {
			displayShow: true,
			isShow: true, // 是否显示
			backgroundColor: '',
			blur: 6
		}
	},
]
// 初始化组件列表
const initComponentsList = (list) => {
	// 公共配置
	const publicConfig = {
		type: 'decoration',
		icon: 'iconyeqian',
		isLock: false, // 是否锁定
		needCommonStyle: true,
		propValue: '',
		span: -1,
		style: {
			height: '100%',
			width: '',
			rotate: 0,
			paddingTop: 0,
			paddingBottom: 0,
			paddingLeft: 0,
			paddingRight: 0
		},
		modelConfig: {
			appId: '',
			appSecret: '',
			modelId: {
				type: '',
				value: ''
			}
		}
	}
	// 返回融合后的配置
	return list.map(el => {
		return Object.assign({}, publicConfig, el)
	})
}
const decorate = {
	type: 'decorate',
	title: '装饰组件',
	show: true,
	order: 11,
	componentList: initComponentsList(decorateComponentsList)
}
export default decorate